module.exports = __webpack_public_path__ + "static/media/users-crown.0812db81.svg";